import { render, staticRenderFns } from "./popout.vue?vue&type=template&id=00c00680&scoped=true&"
import script from "./popout.vue?vue&type=script&lang=js&"
export * from "./popout.vue?vue&type=script&lang=js&"
import style0 from "./popout.vue?vue&type=style&index=0&id=00c00680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c00680",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QScrollArea});
